export default __webpack_public_path__ + "static/media/6.e29f8ad5.svg";